import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import formatNumber from 'flarum/common/utils/formatNumber';
/**
 * The rich card a Discord invite link is upgraded to. It renders inside the
 * link itself, so it is built from spans and holds no interactive elements.
 */
export default class DiscordInviteCard extends Component {
  view() {
    if (!this.attrs.invite) return this.invalid();
    const {
      guild,
      event
    } = this.attrs.invite;
    return m("span", {
      className: event ? 'DiscordInviteCard DiscordInviteCard--event' : 'DiscordInviteCard'
    }, m("span", {
      className: "DiscordInviteCard-heading"
    }, app.translator.trans(event ? 'fof-discord-autolink.forum.event.heading' : 'fof-discord-autolink.forum.invite.heading')), event && this.event(event), m("span", {
      className: "DiscordInviteCard-body"
    }, this.icon(), m("span", {
      className: "DiscordInviteCard-info"
    }, m("span", {
      className: "DiscordInviteCard-name"
    }, this.badge(), guild.name), m("span", {
      className: "DiscordInviteCard-stats"
    }, this.stats())), m("span", {
      className: "Button Button--primary DiscordInviteCard-join"
    }, app.translator.trans('fof-discord-autolink.forum.invite.join'))));
  }
  invalid() {
    return m("span", {
      className: "DiscordInviteCard DiscordInviteCard--invalid"
    }, m("span", {
      className: "DiscordInviteCard-heading"
    }, app.translator.trans('fof-discord-autolink.forum.invite.invalid_heading')), m("span", {
      className: "DiscordInviteCard-body"
    }, m("span", {
      className: "DiscordInviteCard-icon DiscordInviteCard-icon--invalid",
      "aria-hidden": "true"
    }, m("i", {
      className: "fas fa-times"
    })), m("span", {
      className: "DiscordInviteCard-info"
    }, m("span", {
      className: "DiscordInviteCard-name"
    }, app.translator.trans('fof-discord-autolink.forum.invite.invalid_title')), m("span", {
      className: "DiscordInviteCard-stats"
    }, app.translator.trans('fof-discord-autolink.forum.invite.invalid_text')))));
  }
  event(event) {
    return m("span", {
      className: "DiscordInviteCard-event"
    }, event.imageUrl && m("img", {
      className: "DiscordInviteCard-eventImage",
      src: event.imageUrl,
      alt: "",
      loading: "lazy"
    }), this.eventTime(event), m("span", {
      className: "DiscordInviteCard-eventName"
    }, event.name), event.description && m("span", {
      className: "DiscordInviteCard-eventDescription"
    }, event.description), m("span", {
      className: "DiscordInviteCard-eventMeta"
    }, event.channelName && m("span", {
      className: "DiscordInviteCard-eventChannel"
    }, m("i", {
      className: "fas fa-microphone",
      "aria-hidden": "true"
    }), event.channelName), event.interestedCount !== null && m("span", {
      className: "DiscordInviteCard-eventInterested"
    }, m("i", {
      className: "fas fa-user-friends",
      "aria-hidden": "true"
    }), app.translator.trans('fof-discord-autolink.forum.event.interested', {
      count: formatNumber(event.interestedCount)
    }))));
  }
  eventTime(event) {
    const status = event.status || 'scheduled';
    const label = status === 'scheduled' ? event.startsAt && m("time", {
      datetime: event.startsAt,
      title: dayjs(event.startsAt).format('LLLL')
    }, dayjs(event.startsAt).format('llll')) : app.translator.trans(`fof-discord-autolink.forum.event.${status}`);
    return m("span", {
      className: `DiscordInviteCard-eventTime DiscordInviteCard-eventTime--${status}`
    }, m("i", {
      className: status === 'active' ? 'fas fa-broadcast-tower' : 'far fa-calendar',
      "aria-hidden": "true"
    }), label);
  }
  icon() {
    const {
      guild
    } = this.attrs.invite;
    if (guild.iconUrl) {
      return m("img", {
        className: "DiscordInviteCard-icon",
        src: guild.iconUrl,
        alt: "",
        loading: "lazy"
      });
    }

    // Like Discord, stand in for a missing icon with the server's initials.
    const acronym = (guild.name || '').split(/\s+/).filter(Boolean).map(word => Array.from(word)[0]).join('').slice(0, 5);
    return m("span", {
      className: "DiscordInviteCard-icon DiscordInviteCard-icon--acronym",
      "aria-hidden": "true"
    }, acronym);
  }
  badge() {
    const {
      guild
    } = this.attrs.invite;
    const type = guild.verified ? 'verified' : guild.partnered ? 'partnered' : null;
    if (!type) return null;
    const label = app.translator.trans(`fof-discord-autolink.forum.invite.${type}`, {}, true);
    return m("span", {
      className: `DiscordInviteCard-badge DiscordInviteCard-badge--${type}`,
      title: label,
      "aria-label": label
    }, m("i", {
      className: type === 'verified' ? 'fas fa-check' : 'fas fa-infinity',
      "aria-hidden": "true"
    }));
  }
  stats() {
    const {
      guild
    } = this.attrs.invite;
    return [guild.onlineCount !== null && m("span", {
      className: "DiscordInviteCard-online"
    }, m("span", {
      className: "DiscordInviteCard-dot",
      "aria-hidden": "true"
    }), app.translator.trans('fof-discord-autolink.forum.invite.online', {
      count: formatNumber(guild.onlineCount)
    })), guild.memberCount !== null && m("span", {
      className: "DiscordInviteCard-members"
    }, m("span", {
      className: "DiscordInviteCard-dot",
      "aria-hidden": "true"
    }), app.translator.trans('fof-discord-autolink.forum.invite.members', {
      count: formatNumber(guild.memberCount)
    }))];
  }
}
flarum.reg.add('fof-discord-autolink', 'forum/components/DiscordInviteCard', DiscordInviteCard);